import React from 'react';
import style from './BeyondWatching.module.scss';
import uploadImg from '../imgs/WHY05027.JPG';
import trailImg from '../imgs/Wollongong_Breakwater_Lighthouse_Website.jpg';

const BeyondWatching = () => (
    <section className={style.doSection} id="do">
        <div className="wrap">
            <div className="section-head">
                <div className="eyebrow">Beyond watching</div>
                <h2>It's not only what you can see — it's what you can leave behind.</h2>
            </div>
            <div className={style.doGrid}>
                <div className={style.doCard}>
                    <img className={style.cardImg} src={uploadImg} alt="" />
                    <h3>Upload your own film</h3>
                    <p>Got a story about a place you know? Upload a short film straight from the app and drop a pin on the exact spot it happened — a doorway, a bench, a whole street.</p>
                    <a href="https://admin.yesterdaystories.net.au/" target="_blank" rel="noopener noreferrer" className={style.doLink}>Upload a film →</a>
                </div>
                <div className={style.doCard}>
                    <img className={style.cardImg} src={trailImg} alt="Wollongong Breakwater Lighthouse" />
                    <h3>Create your own trail</h3>
                    <p>String several stories together into a trail — a walk through your neighbourhood's history, a family's journey across town, a self-guided tour for visitors.</p>
                    <a href="#about" className={style.doLink}>Build a trail →</a>
                </div>
            </div>
        </div>
    </section>
);

export default BeyondWatching;
